import React, { useState, useEffect, Fragment, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Input,
  Table,
  Select,
  MenuItem,
  TableBody,
  TableContainer,
  Badge,
} from "@mui/material";
import {
  StyledButton,
  StyledTableCell,
  StyledTableRow,
  useStyles,
} from "./styles";
import { toast } from "react-toastify";

// DMP Components
import ArrowStatus from "./Components/ArrowStatus";
import OpponentName from "./Components/OpponentName";
import CustomSelectTag from "./Components/CustomSelectTag";
import CustomTextField from "./Components/CustomTextField";
import DialogBox from "./Components/DialogBox";
import { bestBallCal } from "../../utils/dmp/bestBallCal";
import { checkAdvantage } from "../../utils/dmp/checkAdvantage";
import { bestBallAndAggregateCal } from "../../utils/dmp/bestBallAndAggregateCal";
import { calculateHighestTee } from "../../utils/calculateHighestTee";

// Actions
import { getMinimalCourseList } from "../../redux/actions/courses-action";
import {
  clearIndexParVal,
  getScoreCardParAndIndex,
} from "../../redux/actions/dmp-actions";
import { apiPost, apiPut } from "../../utils/apiRequests";
import ApiEndpoints from "../../utils/ApiEndpoints";
import { useLocation, useParams } from "react-router-dom";
import LoadingTable from "./Components/LoadingTable";
import { calcSumInOut } from "../../utils/dmp/calcSumInOut";

const ScoreboardTableEdit = ({ members, setShow }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { id } = useParams();
  const { state } = useLocation();

  // Selectors
  const courseListSelector = useSelector((state) => state.coursesReducer);
  const parIndexVal = useSelector(
    (state) => state.getScoreCardParAndIndex.data
  );
  const selectedDMPSelector = useSelector(
    (state) => state.getSelectedDMPLeagueReducer.data
  );

  // States
  const [handiCapDiff, setHandiCapDiff] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [disableBtn, setDisableBtn] = useState(false);

  const [courseName, setCourseName] = useState("Course Name");
  const [courseDate, setCourseDate] = useState("");
  const [courseTime, setCourseTime] = useState("");
  const [teamScoreSystem, setTeamScoreSystem] = useState([]);
  const [disableHandicap, setDisableHandicap] = useState(false);
  const [defaultTeesAndGroup, setDefaultTeesAndGroup] = useState([]);
  const [playersInOutScore, setPlayersInOutScore] = useState({
    player1In: 0,
    player1Out: 0,
    player2In: 0,
    player2Out: 0,
    player3In: 0,
    player3Out: 0,
    player4In: 0,
    player4Out: 0,
  });
  const [group, setGroup] = useState({});
  const [winnerTeam, setWinnerTeam] = useState({
    sudden_death: false,
    score_up_group: "",
    won: "",
    score_up: false,
    score_up_value: "",
    autoScoreHoles: "",
  });
  const [refresh, setRefresh] = useState(false);

  const calSumInOut = (arr, grp) => {
    if (grp === "group1") {
      let sum1In = 0;
      let sum1Out = 0;
      let sum2In = 0;
      let sum2Out = 0;
      for (let a = 0; a < 18; a++) {
        if (a < 9) {
          sum1In += +arr[grp][0][a].score;
          sum2In += +arr[grp][1][a].score;
        } else {
          sum1Out += +arr[grp][0][a].score;
          sum2Out += +arr[grp][1][a].score;
        }
      }

      setPlayersInOutScore((pre) => {
        return {
          ...pre,
          player1In: sum1In,
          player1Out: sum1Out,
          player2In: sum2In,
          player2Out: sum2Out,
        };
      });
    } else {
      let sum1In = 0;
      let sum1Out = 0;
      let sum2In = 0;
      let sum2Out = 0;
      for (let a = 0; a < 18; a++) {
        if (a < 9) {
          sum1In += +arr[grp][0][a].score;
          sum2In += +arr[grp][1][a].score;
        } else {
          sum1Out += +arr[grp][0][a].score;
          sum2Out += +arr[grp][1][a].score;
        }
      }

      setPlayersInOutScore((pre) => {
        return {
          ...pre,
          player3In: sum1In,
          player3Out: sum1Out,
          player4In: sum2In,
          player4Out: sum2Out,
        };
      });
    }
  };

  // League Type check
  const checkLeagueType = () => {
    if (
      selectedDMPSelector?.leageData[0]?.season_description.scoring_method ===
      "Best Ball & Aggregate"
    )
      return "bb&a";
    else return "bb";
  };

  // Calculate Player Score
  const handlePlayerScore = (e, grp, player, ind) => {
    if (courseName === "Course Name") {
      return toast.error("Select Course Name First", {
        toastId: "error1",
      });
    }

    if (parIndexVal === undefined) {
      return toast.error("Select Valid Course name", {
        toastId: "error2",
      });
    }

    let tempArr = { ...group };

    var score = parseInt(e);

    if (isNaN(score) || score === 0) {
      return;
    }

    tempArr[grp][player][ind].score = score;

    calSumInOut(tempArr, grp);

    setGroup(tempArr);

    let dmpType = checkLeagueType();

    if (dmpType === "bb&a") {
      // Best ball & Aggregate Calculation

      bestBallAndAggregateCal(
        tempArr,
        setTeamScoreSystem,
        setPlayersInOutScore,
        setOpen,
        setWinnerTeam,
        parIndexVal,
        handiCapDiff
      );
    } else {
      // Best ball Calculation
      bestBallCal(
        tempArr,
        setTeamScoreSystem,
        setPlayersInOutScore,
        setOpen,
        setWinnerTeam,
        parIndexVal,
        handiCapDiff
      );
    }
  };

  useEffect(() => {
    if (courseName !== "Course Name") {
      dispatch(getScoreCardParAndIndex(courseName));
    }

    return () => {
      dispatch(clearIndexParVal());
    };
  }, [courseName]);

  useEffect(() => {
    dispatch(getMinimalCourseList());
  }, []);

  // On Save
  const submitScore = () => {
    if (courseName === "Course Name") {
      return toast.error("Select Course Name");
    }

    if (courseDate === "") {
      return toast.error("Select Date");
    }

    if (courseTime === "") {
      return toast.error("Select Time");
    }

    if (disableHandicap && teamScoreSystem.length <= 9) {
      return toast.error("Complete score card");
    }

    setDisableBtn(true);

    let tempGroupArr = [...group.group1, ...group.group2];

    let [t1, t2, t3, t4] = tempGroupArr;

    let adjusted_score_t1 = 0;
    let adjusted_score_t2 = 0;
    let adjusted_score_t3 = 0;
    let adjusted_score_t4 = 0;

    for (let i = 0; i < 18; i++) {
      if (t1[i].score > t1[i].par) {
        let checkTripleBoggy = t1[i].score - t1[i].par;

        if (checkTripleBoggy >= 3) {
          adjusted_score_t1 += +t1[i].par + 2;
        } else {
          adjusted_score_t1 += +t1[i].score;
        }
      } else {
        adjusted_score_t1 += +t1[i].score;
      }
      if (t2[i].score > t2[i].par) {
        let checkTripleBoggy = t2[i].score - t2[i].par;

        if (checkTripleBoggy >= 3) {
          adjusted_score_t2 += +t2[i].par + 2;
        } else {
          adjusted_score_t2 += +t2[i].score;
        }
      } else {
        adjusted_score_t2 += +t2[i].score;
      }
      if (t3[i].score > t3[i].par) {
        let checkTripleBoggy = t3[i].score - t3[i].par;

        if (checkTripleBoggy >= 3) {
          adjusted_score_t3 += +t3[i].par + 2;
        } else {
          adjusted_score_t3 += +t3[i].score;
        }
      } else {
        adjusted_score_t3 += +t3[i].score;
      }
      if (t4[i].score > t4[i].par) {
        let checkTripleBoggy = t4[i].score - t4[i].par;

        if (checkTripleBoggy >= 3) {
          adjusted_score_t4 += +t4[i].par + 2;
        } else {
          adjusted_score_t4 += +t4[i].score;
        }
      } else {
        adjusted_score_t4 += +t4[i].score;
      }
    }

    let body = {
      match_id: id,
      league_id: state.league_id,
      round_id: state._id,
      groupsdata: {
        course_id: courseName,
        time: courseTime,
        date: courseDate,
        ...(teamScoreSystem.length > 0 && { ...winnerTeam }),
        match_status_track: teamScoreSystem,
        group1: [
          {
            user_id: defaultTeesAndGroup[0].user_id,
            name: defaultTeesAndGroup[0].name,
            tee: handiCapDiff[0].default_tee,
            playing_handicap: handiCapDiff[0][handiCapDiff[0].default_tee],
            gross_score:
              playersInOutScore.player1In + playersInOutScore.player1Out,
            adjusted_score: adjusted_score_t1,
            mp_score: t1,
          },
          {
            user_id: defaultTeesAndGroup[1].user_id,
            name: defaultTeesAndGroup[1].name,
            tee: handiCapDiff[1].default_tee,
            playing_handicap: handiCapDiff[1][handiCapDiff[1].default_tee],
            gross_score:
              playersInOutScore.player2In + playersInOutScore.player2Out,
            adjusted_score: adjusted_score_t2,
            mp_score: t2,
          },
        ],
        group2: [
          {
            user_id: defaultTeesAndGroup[2].user_id,
            name: defaultTeesAndGroup[2].name,
            tee: handiCapDiff[2].default_tee,
            playing_handicap: handiCapDiff[2][handiCapDiff[2].default_tee],
            gross_score:
              playersInOutScore.player3In + playersInOutScore.player3Out,
            adjusted_score: adjusted_score_t3,
            mp_score: t3,
          },
          {
            user_id: defaultTeesAndGroup[3].user_id,
            name: defaultTeesAndGroup[3].name,
            tee: handiCapDiff[3].default_tee,
            playing_handicap: handiCapDiff[3][handiCapDiff[3].default_tee],
            gross_score:
              playersInOutScore.player4In + playersInOutScore.player4Out,
            adjusted_score: adjusted_score_t4,
            mp_score: t4,
          },
        ],
      },
    };

    apiPut("/api/league/dmp-score-entry", body, (res) => {
      toast.success(res.message);
      setShow(false);
    });
  };

  // Setting values for each player with advantage cal
  useEffect(async () => {
    if (handiCapDiff.length > 0) {
      // if previous data exist
      let body = {
        match_id: id,
        round_id: state._id,
      };

      apiPost("/api/league/getmatchscores", body, async (res) => {
        if (res.roundMatchData.length > 0) {
          setCourseName(res.roundMatchData[0].matches.course_id);
          setCourseDate(res.roundMatchData[0].matches.date);
          setCourseTime(res.roundMatchData[0].matches.time);

          let tempGroup = [...group.group1, ...group.group2];

          let [t1, t2, t3, t4] = tempGroup;

          for (let i = 0; i < 18; i++) {
            t1[i].score =
              res.roundMatchData[0].matches.group1[0].mp_score[i].score;
            t2[i].score =
              res.roundMatchData[0].matches.group1[1].mp_score[i].score;
            t3[i].score =
              res.roundMatchData[0].matches.group2[0].mp_score[i].score;
            t4[i].score =
              res.roundMatchData[0].matches.group2[1].mp_score[i].score;
          }

          let tempHandicapArr = [...handiCapDiff];

          for (let i = 0; i < tempHandicapArr.length; i++) {
            tempHandicapArr[i].tees.user_tee.map((val, ind) => {
              if (i === 0) {
                if (
                  res.roundMatchData[0].matches.group1[0].tee === val.tee_color
                ) {
                  tempHandicapArr[i].tees.user_tee[ind].is_default = true;
                } else {
                  tempHandicapArr[i].tees.user_tee[ind].is_default = false;
                }
              } else if (i === 1) {
                if (
                  res.roundMatchData[0].matches.group1[1].tee === val.tee_color
                ) {
                  tempHandicapArr[i].tees.user_tee[ind].is_default = true;
                } else {
                  tempHandicapArr[i].tees.user_tee[ind].is_default = false;
                }
              } else if (i === 2) {
                if (
                  res.roundMatchData[0].matches.group2[0].tee === val.tee_color
                ) {
                  tempHandicapArr[i].tees.user_tee[ind].is_default = true;
                } else {
                  tempHandicapArr[i].tees.user_tee[ind].is_default = false;
                }
              } else {
                if (
                  res.roundMatchData[0].matches.group2[1].tee === val.tee_color
                ) {
                  tempHandicapArr[i].tees.user_tee[ind].is_default = true;
                } else {
                  tempHandicapArr[i].tees.user_tee[ind].is_default = false;
                }
              }
            });
          }

          let tempArr = [];

          for (let a = 0; a < tempHandicapArr?.length; a++) {
            let tempObj = {};

            for (let i = 0; i < tempHandicapArr[a].tees.user_tee.length; i++) {
              if (tempHandicapArr[a].tees.user_tee[i].is_default) {
                tempObj["default_tee"] =
                  tempHandicapArr[a].tees.user_tee[i].tee_color;
              }
              tempObj[tempHandicapArr[a].tees.user_tee[i].tee_color] =
                tempHandicapArr[a].tees.user_tee[i].handicap_value;
              tempObj["advantage"] = false;
            }
            tempArr.push(tempObj);
          }

          if (res.roundMatchData[0].matches.sudden_death) {
            setWinnerTeam((pre) => {
              return {
                ...pre,
                sudden_death: true,
                won: res.roundMatchData[0].matches.won,
              };
            });

            let tempGroupArr = [
              res.roundMatchData[0].matches.group1[0].mp_score,
              res.roundMatchData[0].matches.group1[1].mp_score,
              res.roundMatchData[0].matches.group2[0].mp_score,
              res.roundMatchData[0].matches.group2[1].mp_score,
            ];

            calcSumInOut(tempGroupArr, setPlayersInOutScore);
          }

          setHandiCapDiff(tempArr);

          setLoading(false);
        } else {
          let tempArr1 = [];
          let tempArr2 = [];
          let tempArr3 = [];
          let tempArr4 = [];

          let highestTee = await calculateHighestTee(handiCapDiff)[0];
          let minTee = await calculateHighestTee(handiCapDiff)[1];

          for (let a = 0; a < highestTee.length; a++) {
            let tempArr = [];
            if (highestTee[a].advantage === true) {
              let advanPoint =
                highestTee[a][highestTee[a].default_tee] - minTee;

              for (let i = 0; i < 18; i++) {
                let advantage = parIndexVal?.index_par[i].index <= advanPoint;
                tempArr.push({
                  score: null,
                  advantage: advantage,
                  par: 0,
                  index: 0,
                  hole: i + 1,
                });
              }
            } else {
              for (let i = 0; i < 18; i++) {
                tempArr.push({
                  score: null,
                  advantage: false,
                  par: 0,
                  index: 0,
                  hole: i + 1,
                });
              }
            }

            if (a === 0) {
              tempArr1 = tempArr;
            } else if (a === 1) {
              tempArr2 = tempArr;
            } else if (a === 2) {
              tempArr3 = tempArr;
            } else {
              tempArr4 = tempArr;
            }
          }

          let arr = {
            group1: [tempArr1, tempArr2],
            group2: [tempArr3, tempArr4],
          };

          setGroup(arr);
          setLoading(false);
        }
      });
    } else {
      let tempArr1 = [];
      let tempArr2 = [];
      let tempArr3 = [];
      let tempArr4 = [];

      for (let a = 0; a < 4; a++) {
        let tempArr = [];

        for (let i = 0; i < 18; i++) {
          tempArr.push({
            score: null,
            advantage: false,
            par: 0,
            index: 0,
            hole: i + 1,
          });
        }

        if (a === 0) {
          tempArr1 = tempArr;
        } else if (a === 1) {
          tempArr2 = tempArr;
        } else if (a === 2) {
          tempArr3 = tempArr;
        } else {
          tempArr4 = tempArr;
        }
      }

      let arr = {
        group1: [tempArr1, tempArr2],
        group2: [tempArr3, tempArr4],
      };

      setGroup(arr);
    }
  }, [refresh]);

  // Run when course Name selected
  useEffect(async () => {
    if (parIndexVal !== undefined) {
      let handiCapAdvantage =
        selectedDMPSelector?.leageData[0]?.handicap_diffrential;

      let advan = await checkAdvantage(
        handiCapDiff,
        parIndexVal,
        group,
        handiCapAdvantage
      );

      setGroup(advan);

      let dmpType = checkLeagueType();

      if (dmpType === "bb&a") {
        // Best ball & Aggregate Calculation

        bestBallAndAggregateCal(
          group,
          setTeamScoreSystem,
          setPlayersInOutScore,
          setOpen,
          setWinnerTeam,
          parIndexVal,
          handiCapDiff
        );
      } else {
        // Best ball Calculation

        bestBallCal(
          group,
          setTeamScoreSystem,
          setPlayersInOutScore,
          setOpen,
          setWinnerTeam,
          parIndexVal,
          handiCapDiff
        );
      }
    }
  }, [parIndexVal, handiCapDiff]);

  // Get Group And Tees
  useEffect(() => {
    let body = {
      match_id: id,
      league_id: state.league_id,
    };
    apiPost(`${ApiEndpoints.dmpgroupandtees.base}`, body, (res) => {
      setHandiCapDiff(res.groupsData1);
      setRefresh(!refresh);
      setDefaultTeesAndGroup(res.groupsData1);
    });
  }, []);

  // Setting Group and Tees
  useEffect(() => {
    let tempArr = [];

    for (let a = 0; a < handiCapDiff?.length; a++) {
      let tempObj = {};

      for (let i = 0; i < handiCapDiff[a].tees.user_tee.length; i++) {
        if (handiCapDiff[a].tees.user_tee[i].is_default) {
          tempObj["default_tee"] = handiCapDiff[a].tees.user_tee[i].tee_color;
        }
        tempObj[handiCapDiff[a].tees.user_tee[i].tee_color] =
          handiCapDiff[a].tees.user_tee[i].handicap_value;
        tempObj["advantage"] = false;
      }
      tempArr.push(tempObj);
      tempObj = {};
    }

    setHandiCapDiff(tempArr);
  }, [refresh]);

  // Auto Filling Function
  useEffect(async () => {
    if (winnerTeam.autoScoreHoles !== "") {
      let tempArr = [...group.group1, ...group.group2];

      let [t1, t2, t3, t4] = tempArr;

      let filterArr = await calculateHighestTee(handiCapDiff)[0];
      let minTee = await calculateHighestTee(handiCapDiff)[1];

      for (let i = 0; i < filterArr.length; i++) {
        let user_handicap = filterArr[i][filterArr[i].default_tee];

        if (filterArr[i].advantage) {
          let advanPointInAutoScore =
            filterArr[i][filterArr[i].default_tee] - minTee;
          let advanPointInNormal =
            filterArr[i][filterArr[i].default_tee] - minTee;

          let handiCapAdvantage =
            selectedDMPSelector?.leageData[0]?.handicap_diffrential;
          advanPointInNormal = Math.round(
            (advanPointInNormal * parseInt(handiCapAdvantage)) / 100
          );

          for (let j = 9; j < 18; j++) {
            if (j < teamScoreSystem.length) {
              // With Provide

              let advantage =
                parIndexVal.index_par[j].index <= advanPointInNormal;

              if (i === 0) {
                t1[j] = {
                  ...t1[j],
                  advantage: advantage,
                };
              } else if (i === 1) {
                t2[j] = {
                  ...t2[j],
                  advantage: advantage,
                };
              } else if (i === 2) {
                t3[j] = {
                  ...t3[j],
                  advantage: advantage,
                };
              } else {
                t4[j] = {
                  ...t4[j],
                  advantage: advantage,
                };
              }
            } else {
              let advantage =
                parIndexVal.index_par[j].index <= advanPointInAutoScore;
              // With 100%

              if (i === 0) {
                t1[j] = {
                  ...t1[j],
                  advantage: advantage,
                  score:
                    user_handicap >= parIndexVal.index_par[j].index
                      ? parIndexVal.index_par[j].par + 1
                      : parIndexVal.index_par[j].par,
                };
              } else if (i === 1) {
                t2[j] = {
                  ...t2[j],
                  advantage: advantage,
                  score:
                    user_handicap >= parIndexVal.index_par[j].index
                      ? parIndexVal.index_par[j].par + 1
                      : parIndexVal.index_par[j].par,
                };
              } else if (i === 2) {
                t3[j] = {
                  ...t3[j],
                  advantage: advantage,
                  score:
                    user_handicap >= parIndexVal.index_par[j].index
                      ? parIndexVal.index_par[j].par + 1
                      : parIndexVal.index_par[j].par,
                };
              } else {
                t4[j] = {
                  ...t4[j],
                  advantage: advantage,
                  score:
                    user_handicap >= parIndexVal.index_par[j].index
                      ? parIndexVal.index_par[j].par + 1
                      : parIndexVal.index_par[j].par,
                };
              }
            }
          }
        } else {
          for (let j = 9; j < 18; j++) {
            // With 100%

            if (j >= teamScoreSystem.length) {
              if (i === 0) {
                t1[j] = {
                  ...t1[j],
                  score:
                    user_handicap >= parIndexVal.index_par[j].index
                      ? parIndexVal.index_par[j].par + 1
                      : parIndexVal.index_par[j].par,
                };
              } else if (i === 1) {
                t2[j] = {
                  ...t2[j],
                  score:
                    user_handicap >= parIndexVal.index_par[j].index
                      ? parIndexVal.index_par[j].par + 1
                      : parIndexVal.index_par[j].par,
                };
              } else if (i === 2) {
                t3[j] = {
                  ...t3[j],
                  score:
                    user_handicap >= parIndexVal.index_par[j].index
                      ? parIndexVal.index_par[j].par + 1
                      : parIndexVal.index_par[j].par,
                };
              } else {
                t4[j] = {
                  ...t4[j],
                  score:
                    user_handicap >= parIndexVal.index_par[j].index
                      ? parIndexVal.index_par[j].par + 1
                      : parIndexVal.index_par[j].par,
                };
              }
            }
          }
        }
      }

      let mergeArr = {
        group1: [t1, t2],
        group2: [t3, t4],
      };

      calcSumInOut(tempArr, setPlayersInOutScore);

      setGroup(mergeArr);
    }
  }, [winnerTeam]);

  useEffect(() => {
    let filterG1 = false;
    let filterG2 = false;
    for (let i = 0; i < group?.group1?.length; i++) {
      let filter =
        group.group1[i].filter((el) => el.score !== null).length >= 1;

      if (filter) {
        filterG1 = filter;
        break;
      }
    }

    for (let i = 0; i < group?.group2?.length; i++) {
      let filter =
        group.group1[i].filter((el) => el.score !== null).length >= 1;

      if (filter) {
        filterG2 = filter;
        break;
      }
    }

    if (filterG1 || filterG2) {
      setDisableHandicap(true);
    } else {
      setDisableHandicap(false);
    }
  }, [group]);

  return (
    <Fragment>
      <DialogBox
        open={open}
        setOpen={setOpen}
        value={winnerTeam}
        setValue={setWinnerTeam}
        members={defaultTeesAndGroup}
      />

      {loading ? (
        <LoadingTable />
      ) : (
        <>
          <TableContainer sx={{ padding: 5 }}>
            <Table sx={{ padding: "0 !important" }}>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell sx={{ width: "180px" }} rowSpan={3}>
                    <Box sx={{ marginRight: "0 !important" }}>
                      <Select
                        variant="standard"
                        disableUnderline
                        fullWidth
                        value={courseName}
                        sx={{
                          maxWidth: "180px",
                          width: "180px",
                          "::before": { display: "none" },
                        }}
                        className={classes.selectBox}
                        onChange={(e) => setCourseName(e.target.value)}
                        disabled={disableHandicap}
                      >
                        <MenuItem selected value="Course Name" disabled>
                          Course Name
                        </MenuItem>
                        {!courseListSelector?.loading &&
                          courseListSelector?.data &&
                          courseListSelector?.data.length > 0 &&
                          courseListSelector.data.map(({ _id, name }) => {
                            return (
                              <MenuItem key={_id} value={_id}>
                                {name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <Input
                        type="date"
                        fullWidth
                        value={courseDate}
                        onChange={(e) => setCourseDate(e.target.value)}
                        className={classes.selectBox}
                        sx={{ "::before": { display: "none" } }}
                      />
                      <Input
                        type="time"
                        fullWidth
                        value={courseTime}
                        onChange={(e) => setCourseTime(e.target.value)}
                        className={classes.selectBox}
                        sx={{ "::before": { display: "none" } }}
                      />
                    </Box>
                  </StyledTableCell>

                  {/* Holes Row  */}
                  <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                    HOLES
                  </StyledTableCell>
                  {Array.apply(null, Array(18)).map((v, i) =>
                    i === 9 ? (
                      <>
                        <StyledTableCell
                          align="center"
                          sx={{ fontWeight: 700 }}
                          key={i}
                        >
                          OUT
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {i + 1}
                        </StyledTableCell>
                      </>
                    ) : (
                      <StyledTableCell align="center" key={i}>
                        {i + 1}
                      </StyledTableCell>
                    )
                  )}
                  <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                    IN
                  </StyledTableCell>
                  <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                    TOTAL
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                    INDEX
                  </StyledTableCell>
                  {parIndexVal?.index_par ? (
                    <>
                      {Array.apply(null, Array(18)).map((v, i) =>
                        i === 9 ? (
                          <>
                            <StyledTableCell
                              align="center"
                              sx={{ fontWeight: 700 }}
                            ></StyledTableCell>
                            <StyledTableCell align="center">
                              {parIndexVal?.index_par[i].index}
                            </StyledTableCell>
                          </>
                        ) : (
                          <StyledTableCell align="center">
                            {parIndexVal?.index_par[i].index}
                          </StyledTableCell>
                        )
                      )}
                      <StyledTableCell
                        sx={{ fontWeight: 700 }}
                        align="center"
                      ></StyledTableCell>
                      <StyledTableCell
                        sx={{ fontWeight: 700 }}
                        align="center"
                      ></StyledTableCell>
                    </>
                  ) : (
                    <>
                      {Array.apply(null, Array(18)).map((v, i) =>
                        i === 9 ? (
                          <>
                            <StyledTableCell
                              align="center"
                              sx={{ fontWeight: 700 }}
                              key={i}
                            ></StyledTableCell>
                            <StyledTableCell align="center">0</StyledTableCell>
                          </>
                        ) : (
                          <StyledTableCell align="center">0</StyledTableCell>
                        )
                      )}
                      <StyledTableCell
                        sx={{ fontWeight: 700 }}
                        align="center"
                      ></StyledTableCell>
                      <StyledTableCell
                        sx={{ fontWeight: 700 }}
                        align="center"
                      ></StyledTableCell>
                    </>
                  )}
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                    PAR
                  </StyledTableCell>
                  {parIndexVal?.index_par ? (
                    <>
                      {Array.apply(null, Array(18)).map((v, i) =>
                        i === 9 ? (
                          <>
                            <StyledTableCell
                              align="center"
                              sx={{ fontWeight: 700 }}
                              key={i}
                            >
                              36
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {parIndexVal?.index_par[i].par}
                            </StyledTableCell>
                          </>
                        ) : (
                          <StyledTableCell align="center">
                            {parIndexVal?.index_par[i].par}
                          </StyledTableCell>
                        )
                      )}
                      <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                        36
                      </StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                        72
                      </StyledTableCell>
                    </>
                  ) : (
                    <>
                      {Array.apply(null, Array(18)).map((v, i) =>
                        i === 9 ? (
                          <>
                            <StyledTableCell
                              align="center"
                              sx={{ fontWeight: 700 }}
                              key={i}
                            ></StyledTableCell>
                            <StyledTableCell align="center">0</StyledTableCell>
                          </>
                        ) : (
                          <StyledTableCell align="center">0</StyledTableCell>
                        )
                      )}
                      <StyledTableCell
                        sx={{ fontWeight: 700 }}
                        align="center"
                      ></StyledTableCell>
                      <StyledTableCell
                        sx={{ fontWeight: 700 }}
                        align="center"
                      ></StyledTableCell>
                    </>
                  )}
                </StyledTableRow>

                {/* Group 1 */}

                {/* Player 1 */}
                <StyledTableRow>
                  <StyledTableCell align="center">
                    <OpponentName
                      value={
                        members.length > 0
                          ? members[0]?.matches?.group1[0].name
                          : defaultTeesAndGroup[0]?.name
                      }
                      color="#0000FF"
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <CustomSelectTag
                      data={handiCapDiff}
                      index={0}
                      setValue={setHandiCapDiff}
                      disable={disableHandicap}
                    />
                  </StyledTableCell>
                  {group.group1 &&
                    group.group1[0].map((v, i) => (
                      <>
                        {i === 9 && (
                          <StyledTableCell align="center" key={i}>
                            {playersInOutScore.player1In}
                          </StyledTableCell>
                        )}

                        <StyledTableCell align="center">
                          <Badge
                            color="secondary"
                            badgeContent={v?.advantage ? 1 : 0}
                            sx={{
                              "& .MuiBadge-badge": {
                                width: "10px",
                                height: "15px",
                                fontSize: "10px",
                              },
                            }}
                          >
                            <CustomTextField
                              value={v}
                              handlePlayerScore={(e) =>
                                handlePlayerScore(
                                  e.target.value,
                                  "group1",
                                  0,
                                  i
                                )
                              }
                            />
                          </Badge>
                        </StyledTableCell>
                      </>
                    ))}
                  <StyledTableCell align="center">
                    {playersInOutScore.player1Out}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {playersInOutScore.player1In + playersInOutScore.player1Out}
                  </StyledTableCell>
                </StyledTableRow>
                {/* Player 2 */}
                <StyledTableRow>
                  <StyledTableCell align="center">
                    <OpponentName
                      value={
                        members.length > 0
                          ? members[0]?.matches?.group1[1].name
                          : defaultTeesAndGroup[1]?.name
                      }
                      color="#0000FF"
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <CustomSelectTag
                      data={handiCapDiff}
                      index={1}
                      setValue={setHandiCapDiff}
                      disable={disableHandicap}
                    />
                  </StyledTableCell>
                  {group.group1 &&
                    group.group1[1]?.map((v, i) => (
                      <>
                        {i === 9 && (
                          <StyledTableCell align="center" key={i}>
                            {playersInOutScore.player2In}
                          </StyledTableCell>
                        )}
                        <StyledTableCell align="center">
                          <Badge
                            color="secondary"
                            badgeContent={v?.advantage ? 1 : 0}
                            sx={{
                              "& .MuiBadge-badge": {
                                width: "10px",
                                height: "15px",
                                fontSize: "10px",
                              },
                            }}
                          >
                            <CustomTextField
                              value={v}
                              handlePlayerScore={(e) =>
                                handlePlayerScore(
                                  e.target.value,
                                  "group1",
                                  1,
                                  i
                                )
                              }
                            />
                          </Badge>
                        </StyledTableCell>
                      </>
                    ))}
                  <StyledTableCell align="center">
                    {playersInOutScore.player2Out}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {playersInOutScore.player2In + playersInOutScore.player2Out}
                  </StyledTableCell>
                </StyledTableRow>

                {/* vs row  start*/}
                <StyledTableRow>
                  <StyledTableCell align="center">
                    <OpponentName value="vs" color="#000" />
                  </StyledTableCell>
                  <StyledTableCell align="center"></StyledTableCell>
                  {Array.apply(null, Array(18)).map((v, i) =>
                    i === 9 ? (
                      <>
                        <StyledTableCell align="center"></StyledTableCell>
                        <StyledTableCell align="center">
                          {teamScoreSystem[i] !== undefined && (
                            <ArrowStatus
                              value={teamScoreSystem[i].count}
                              color={
                                teamScoreSystem[i].label === "group1"
                                  ? "#0000FF"
                                  : "#FF0000"
                              }
                            />
                          )}
                        </StyledTableCell>
                      </>
                    ) : (
                      <StyledTableCell align="center">
                        {teamScoreSystem[i] !== undefined && (
                          <ArrowStatus
                            value={teamScoreSystem[i].count}
                            color={
                              teamScoreSystem[i].label === "group1"
                                ? "#0000FF"
                                : "#FF0000"
                            }
                          />
                        )}
                      </StyledTableCell>
                    )
                  )}
                  <StyledTableCell align="center" colSpan={2}>
                    {winnerTeam.sudden_death && (
                      <p
                        style={{
                          marginBottom: 0,
                          color:
                            winnerTeam.won === "group1" ? "#0000FF" : "#FF0000",
                        }}
                      >
                        Won In Play Off
                      </p>
                    )}
                  </StyledTableCell>
                </StyledTableRow>

                {/* Group 2 */}

                {/* Player 1 */}
                <StyledTableRow>
                  <StyledTableCell align="center">
                    <OpponentName
                      value={
                        members.length > 0
                          ? members[0]?.matches?.group2[0].name
                          : defaultTeesAndGroup[2]?.name
                      }
                      color="#FF0000"
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <CustomSelectTag
                      data={handiCapDiff}
                      index={2}
                      setValue={setHandiCapDiff}
                      disable={disableHandicap}
                    />
                  </StyledTableCell>
                  {group.group2 &&
                    group.group2[0].map((v, i) => (
                      <>
                        {i === 9 && (
                          <StyledTableCell align="center" key={i}>
                            {playersInOutScore.player3In}
                          </StyledTableCell>
                        )}
                        <StyledTableCell align="center">
                          <Badge
                            color="secondary"
                            badgeContent={v?.advantage ? 1 : 0}
                            sx={{
                              "& .MuiBadge-badge": {
                                width: "10px",
                                height: "15px",
                                fontSize: "10px",
                              },
                            }}
                          >
                            <CustomTextField
                              value={v}
                              handlePlayerScore={(e) =>
                                handlePlayerScore(
                                  e.target.value,
                                  "group2",
                                  0,
                                  i
                                )
                              }
                            />
                          </Badge>
                        </StyledTableCell>
                      </>
                    ))}
                  <StyledTableCell align="center">
                    {playersInOutScore.player3Out}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {playersInOutScore.player3In + playersInOutScore.player3Out}
                  </StyledTableCell>
                </StyledTableRow>
                {/* Player 2 */}
                <StyledTableRow>
                  <StyledTableCell align="center">
                    <OpponentName
                      value={
                        members.length > 0
                          ? members[0]?.matches?.group2[1].name
                          : defaultTeesAndGroup[3]?.name
                      }
                      color="#FF0000"
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <CustomSelectTag
                      data={handiCapDiff}
                      index={3}
                      setValue={setHandiCapDiff}
                      disable={disableHandicap}
                    />
                  </StyledTableCell>
                  {group.group2 &&
                    group.group2[1].map((v, i) => (
                      <>
                        {i === 9 && (
                          <StyledTableCell align="center" key={i}>
                            {playersInOutScore.player4In}
                          </StyledTableCell>
                        )}
                        <StyledTableCell align="center">
                          <Badge
                            color="secondary"
                            badgeContent={v?.advantage ? 1 : 0}
                            sx={{
                              "& .MuiBadge-badge": {
                                width: "10px",
                                height: "15px",
                                fontSize: "10px",
                              },
                            }}
                          >
                            <CustomTextField
                              value={v}
                              handlePlayerScore={(e) =>
                                handlePlayerScore(
                                  e.target.value,
                                  "group2",
                                  1,
                                  i
                                )
                              }
                            />
                          </Badge>
                        </StyledTableCell>
                      </>
                    ))}
                  <StyledTableCell align="center">
                    {+playersInOutScore.player4Out}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {+playersInOutScore.player4In +
                      +playersInOutScore.player4Out}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <StyledButton onClick={submitScore} disabled={disableBtn}>
            Save
          </StyledButton>
        </>
      )}
    </Fragment>
  );
};

export default ScoreboardTableEdit;
